/**
 * Service module for the Vehicle entity
 * @module VehicleService
 *
 * This module contains requests regarding the Read or Update of Vehicles
 */
import { InventoryAxios, DecoderAxios, PublisherAxios } from '@/config/axios';

/**
 * Returns a list of shared vehicles based on provided id
 * @param {string} id Identifier of the vehicle's shared
 * @param {object} config Represents an Axios request config object
 * @returns {Promise} Axios promise object represents the list of vehicles
 */
export function getVehicleShareById(id, config = {}) {
  return InventoryAxios.get(`/vehicle-shares/shares/${id}`, config);
}
/**
 * Returns a list of vehicles based on the publisher.
 * @param {string} token Identifier of the publisher
 * @param {object} config Represents an Axios request config object
 * @returns {Promise} Axios promise object represents the list of vehicles
 */
export function getVehicleByPublisher(token = process.env.VUE_APP_TOKEN, config = {}) {
  return PublisherAxios.get(
    `/search/vehicles?limit=20&token=${token}&lists=make,model,body_style,year`,
    config
  );
}
/**
 * Returns a vehicle object by decoding the vin number
 * @param {string} vin Unique identifier of a vehicle
 * @param {object} config Represents an Axios request config object
 * @returns {Promise} Axios promise object represents the list of vehicles
 */
export function decodeVehicleByVin(vin, config = {}) {
  return DecoderAxios.get(`/vin/${vin}`, config);
}

export default {
  getVehicleShareById,
  getVehicleByPublisher,
  decodeVehicleByVin,
};
